<template>
    <modal :show.sync=show modalClasses="large-sized-modal modal-hide-footer">
        <h3 slot="header" class="mb-0 font-weight-500">Payslip History</h3>
        <PayslipStatementHistory />
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import '@/assets/js/formValidations.js'
import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
import PayslipStatementHistory from "@/views/Commission/Payout/PayoutSummaries/Tables/PayslipStatementHistory.vue"

export default {
    props:{
        payslip_history: Boolean
    },
    mixins: [notifyFunctionMixin],
    components: {
        Modal,
        PayslipStatementHistory,
    },
    computed: {
        show: {
            get() {
                return this.payslip_history;
            },
            set(newVal) {
                this.$emit('update:payslip_history', newVal);
            },
        },
    },
    methods: {
        viewDetails(){
            this.show = true
        }
    }
}
</script>